<template>
  <div class="email">
    <div class="r-text-intro">פרטים אישיים</div>
    <div class="r-text-headline-paragraph">
      לאיזה מייל לשלוח עדכונים על קופת הגמל להשקעה?
    </div>
    <div class="r-form-row">
        <default-text-input
          :value="email"
          type="email"
          label="כתובת מייל"
          autocomplete="email"
          validations="required|email"
          @observe="observe"
          @input="setEmail"/>
      </div>
    <default-button label="הבא >" @click="nextPage" :disable="locked" :loading="locked"/>
  </div>
</template>

<script>

import { mapMutations, mapState } from 'vuex';
import WizardPage from '@/mixins/WizardPage';
import DefaultButton from '@/components/styled/DefaultButton';
import DefaultTextInput from '@/components/styled/DefaultTextInput';

export default {
  name: 'Email',
  components: { DefaultButton, DefaultTextInput },
  mixins: [WizardPage],
  computed: {
    ...mapState('meitavDash/openFund', ['email']),
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setEmail']),
  },
};
</script>
